import { LayoutDashboard, Clock } from "lucide-react";

const DashboardPage = () => {
  return (
    <div data-testid="dashboard-page">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 flex items-center gap-3">
          <LayoutDashboard className="text-[#0284c7]" size={28} />
          Dashboard
        </h1>
        <p className="text-gray-600 mt-2">Welcome to the GasMan4U admin dashboard</p>
      </div>

      {/* Coming Soon Card */}
      <div className="coming-soon-card max-w-2xl mx-auto" data-testid="dashboard-coming-soon">
        <div className="w-20 h-20 bg-[#6BB5E0]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Clock className="text-[#0284c7]" size={40} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Coming Soon</h2>
        <p className="text-gray-600 max-w-md mx-auto">
          We're working hard to bring you an amazing dashboard experience. 
          Stay tuned for analytics, insights, and more!
        </p>
        <div className="mt-8 flex justify-center gap-2">
          <div className="w-2 h-2 bg-[#6BB5E0] rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-[#6BB5E0] rounded-full animate-pulse" style={{animationDelay: '0.1s'}}></div>
          <div className="w-2 h-2 bg-[#6BB5E0] rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
